import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import axiosInstance from "../../../utils/axios";
import { IErrorResponse } from "../../querys/querys.enum";
import { MutationKeys } from "../../mutation/mutation.enum";

export type OneTimeNotificationReqVariables = {
  timeToReceive: `${string}:${string}AM` | `${string}:${string}PM` | undefined;
  platform: ("android" | "ios" | "web")[];
  premium: boolean | undefined;
  notificationType: ("marketing" | "learning")[];
  olderThanDays: number;
  earlierThanDays: number;
  premiumTobeCancelled: boolean | undefined;
  premiumNotTobeCancelled: boolean | undefined;
  spreadTime: number;
};

const useOneTimeNotificationReq = async (
  data: OneTimeNotificationReqVariables
) => {
  const response = await axiosInstance.post<Partial<IErrorResponse>>(
    `notifications/one-time`,
    {
      ...data,
    }
  );

  return response.data;
};

const useOneTimeNotification = (
  options?: Partial<
    UseMutationOptions<
      Partial<IErrorResponse>,
      AxiosError<IErrorResponse>,
      OneTimeNotificationReqVariables
    >
  >
) => {
  return useMutation({
    mutationKey: [MutationKeys.UPDATE_ONE_TIME_NOTIFICATION],
    mutationFn: async (data) => {
      return await useOneTimeNotificationReq(data);
    },
    ...options,
  });
};
export default useOneTimeNotification;
